module.exports = __webpack_public_path__ + "static/img/22.b04a22e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/22.png
// module id = gomM
// module chunks = 0